import { createContext } from 'react';
const AnalyticsNextContext = createContext({
    getAtlaskitAnalyticsContext: () => [],
    getAtlaskitAnalyticsEventHandlers: () => [],
});
export default AnalyticsNextContext;
//# sourceMappingURL=context.js.map